import { ReactComponent as ErrorIcon } from 'assets/icons/fonbet/error-icon.svg';
import { PaymentStatus } from 'constants/payment';
import { useAmount, usePaymentError, useRetry, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';

import { BaseCard, Button } from '../ui';

const CheckError = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { formattedFullAmount } = useAmount();
  const { t } = useTranslate();
  const { handleRetryPayment, isLoading } = useRetry();
  const { getPaymentError } = usePaymentError();

  return (
    <BaseCard>
      <div className="flex flex-col gap-6">
        <div>
          <div className="flex justify-center items-center gap-3">
            <ErrorIcon className="w-6 md:w-8 h-6 md:h-8" />
            <span className="text-lg md:text-2xl leading-5 md:leading-[30px] font-semibold text-fonbet-black">
              {t('fonbet.payment-rejected')}
            </span>
          </div>
          <p className="text-center text-fonbet-red text-base md:text-lg leading-5 md:leading-[22px] font-normal mt-4">
            {getPaymentError(paymentData?.error, 'try_again_later')}
          </p>
        </div>
        <div className="text-base md:text-lg leading-5 md:leading-[30px] flex flex-col gap-4 md:gap-6">
          <dl className="flex flex-1">
            <dt className="text-fonbet-gray-200 w-full">{t('fonbet.info.transaction-number')}</dt>
            <dd className="text-fonbet-black md:text-xl w-full font-medium text-right">
              №{paymentData?.ID}
            </dd>
          </dl>
          <dl className="flex flex-1">
            <dt className="text-fonbet-gray-200 w-full">{t('fonbet.info.payment-amount')}</dt>
            <dd className="text-fonbet-black md:text-xl w-full font-medium text-right">
              {formattedFullAmount}
            </dd>
          </dl>
        </div>
        {paymentData?.status === PaymentStatus.RETRYABLE_FAILED && (
          <Button isLoading={isLoading} onClick={handleRetryPayment}>
            {t('fonbet.repeat-payment')}
          </Button>
        )}
        {paymentData?.returnURL && (
          <Button kind={ButtonKinds.secondary} href={paymentData?.returnURL}>
            {t('fonbet.home-page')}
          </Button>
        )}
      </div>
    </BaseCard>
  );
};

export { CheckError };
